import Swiper from 'swiper';
import { Navigation, Controller, EffectFade } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/effect-fade';

export function initSwipers() {
  const testimonialSwiper = document.querySelector('.testimonial-carousel');

  if (!testimonialSwiper) {
    return;
  }

  const testimonialText = testimonialSwiper.querySelector('.swiper-testimonials-text');
  const testimonialImage = testimonialSwiper.querySelector('.swiper-testimonials-image');

  if (!testimonialText || !testimonialImage) {
    return;
  }

  testimonialSwiper.classList.add('loaded');

  const textSwiper = new Swiper(testimonialText, {
    modules: [Navigation, Controller, EffectFade],
    effect: 'fade',
    loop: true,
    allowTouchMove: false,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });

  const imageSwiper = new Swiper(testimonialImage, {
    modules: [Controller, EffectFade],
    loop: true,
    effect: 'fade',
    allowTouchMove: false,
    lazy: true,
  });

  imageSwiper.controller.control = textSwiper;
  textSwiper.controller.control = imageSwiper;
}

document.addEventListener('DOMContentLoaded', () => {
  initSwipers();
});